import React, { useRef } from "react";

// Components
import CardCalonMarketingAssociate from "./card-calon-marketing-associate";
import CardTraining from "./card-training";

// Ctx
import { useTrainingCtx } from "pages/dashboard/training/useTraining";

const ContentCard = () => {
  const { listTraining } = useTrainingCtx();
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full">
      {/* Navigation Buttons */}
      <div className="flex justify-end gap-2 mb-2">
        <button
          onClick={scrollLeft}
          className="w-6 h-6 rounded-full border border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-center shadow-sm transition-colors"
          aria-label="Scroll left"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button
          onClick={scrollRight}
          className="w-6 h-6 rounded-full border border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-center shadow-sm transition-colors"
          aria-label="Scroll right"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
      <div
        ref={scrollContainerRef}
        className="flex flex-start w-full overflow-x-auto hide-scrollbar"
      >
        <CardCalonMarketingAssociate />
        {!!listTraining?.data?.data?.length &&
          listTraining?.data?.data.map((training, idx) => (
            <CardTraining
              key={`list-training-${training?.id}-${idx}`}
              {...training}
            />
          ))}
      </div>
    </div>
  );
};

export default ContentCard;
